import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "breadcrumb-nav"
}
const _hoisted_2 = { class: "breadcrumb NKT-P2" }
const _hoisted_3 = { class: "breadcrumb-item mb-1" }
const _hoisted_4 = ["onClick"]

import { useBreadcrumbStore } from '@/stores/BreadcrumbStore'
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const breadcrumbStore = useBreadcrumbStore()

const currentRouteName = ref()

watch(
  () => route.meta.breadcrumbs,
  (newVal) => {
    currentRouteName.value = newVal
  },
  { immediate: true }
)

const goTo = (link: string | null) => {
  if (link) {
    router.push({ path: link })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: _normalizeClass({ header: _unref(route).name !== 'home' })
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Home")
          ])),
          _: 1
        }, 8, ["class"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRouteName.value, (route, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          onClick: ($event: any) => (goTo(route.displayLink)),
          class: _normalizeClass(["breadcrumb-item mb-1", [
          ,
          { active: index === currentRouteName.value.length - 1 },
          { link: route.displayLink !== null }
        ]])
        }, _toDisplayString(route.displayName
            ? route.displayName
            : _unref(breadcrumbStore).link
            ? _unref(breadcrumbStore).link
            : route.name), 11, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})